<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Orders</li>
    </ol>
  </nav>

  <div class="row align-items-center">
    <div class="col">
    </div>
    <div class="col text-right">
      <button type="submit" *ngIf="step == 1" (click)="reviewAndConfirm()" class="btn btn-orange ml-2">Next</button>
      <button type="submit" *ngIf="step == 2"  (click)="submitShipment()" class="btn btn-orange ml-2">Submit</button>
    </div>
  </div>

  <form [hidden]="step !== 1"
        *ngIf="order?.orderStatus == 'READY_TO_SHIP' || order?.orderStatus == 'AWAITING_CARRIER'">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h4 class="text-black mb-3">Shipping Options</h4>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label">Pickup Area Pincode</label>
                <input type="text" id="pickUp" class="form-control" [(ngModel)]="order.pickupAreaPinCode"
                       [ngModelOptions]="{standalone: true}" disabled>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label" for="deliveryPinCode">Delivery Area Pincode</label>
                <input type="text" id="deliveryPinCode" class="form-control"
                       [(ngModel)]="order.deliveryAreaPinCode" [ngModelOptions]="{standalone: true}" disabled>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label">Approximate Weight (kg)</label>
                <input type="text" id="weight" class="form-control" [(ngModel)]="order.weightOfOrder"
                       [ngModelOptions]="{standalone: true}" disabled>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group ">
                <label class="control-label">Dimensions (cm)</label>
                <div class="row">
                  <div class="col-4">
                    <input type="text" id="l" class="form-control" [(ngModel)]="lBoxLength"
                           [ngModelOptions]="{standalone: true}" disabled>
                  </div>
                  <div class="col-4">
                    <input type="text" id="w" class="form-control" [(ngModel)]="lBoxWidth" appOnlyNumbers
                           [ngModelOptions]="{standalone: true}" disabled>
                  </div>
                  <div class="col-4">
                    <input type="text" id="h" class="form-control" [(ngModel)]="lBoxHeight" appOnlyNumbers
                           [ngModelOptions]="{standalone: true}" disabled>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 mt-4">
              <div class="form-check">
                <label class="control-label"></label>
                <input class="form-check-input" type="checkbox" id="paymentMethod" [(ngModel)]="paymentMethod"
                       [ngModelOptions]="{standalone: true}" disabled>
                <label class="form-check-label" for="paymentMethod">COD order</label>
                <small *ngIf="paymentMethod" class="claimedRight" ngbTooltip="Additional Charges for COD Rs40/- or 1.5% whichever is higher will be charged extra. Charges may differ for few carriers.">Additional Charges for COD Rs40/- or 1.5% whichever is higher will be charged extra. Charges may differ for few carriers.</small>
              </div>
            </div>
          </div>
          <div class="mt-3" *ngIf="costEstimation">
            <div class="table-3" style="overflow-x:auto;">
              <table class="table packing-table packing-table-2">
                <thead class="thead-light">
                <tr>
                  <th>Select</th>
                  <th></th>
                  <th>Courier Partner</th>
                  <th>Courier Mode</th>
                  <th>Price</th>
                  <th>Pickup Available</th>
                </tr>
                </thead>

                <tbody *ngFor="let co of costEstimation; let i=index;">
                <tr *ngFor="let c of co.costEstimates; let j=index;">
                  <td>
                    <div class="form-radio">
                      <input type="radio" id="cost+{{i}}+{{j}}" (change)="selectCost(c)" required
                             name="costEstimate">
                      <label for="cost+{{i}}+{{j}}"></label>
                    </div>
                  </td>
                  <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                  <td>
                    {{(co.carrierCode == 'SD' ? 'Shift' :
                    (co.carrierCode == 'DL' ? 'Delhivery' :
                    (co.carrierCode == 'GT' ? 'Gati' :
                    (co.carrierCode == 'DZ' ? 'Dotzot' :
                    (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                    (co.carrierCode == 'SF' ? 'Shadow Fax' :
                    (co.carrierCode == 'BD' ? 'Blue Dart' :
                    (co.carrierCode == 'PR' ? 'Pickrr' :
                    (co.carrierCode == 'EX' ? 'EcomXpress Pro' :
                    (co.carrierCode == 'DE' ? 'Delhivery' :
                    (co.carrierCode == 'SG' ? 'Shippigo' :
                    (co.carrierCode == 'EG' ? 'EcomXpress EGS' :
                    (co.carrierCode == 'DN' ? 'Dunzo' :
                    (co.carrierCode == 'WF' ? 'Borzo' :
                    (co.carrierCode == 'UE' ? 'UdaanExpress' :
                    (co.carrierCode == 'XB' ? 'Xpressbees' :
                    (co.carrierCode == 'KE' ? 'Kerry' :
                    (co.carrierCode == 'FE' ? 'FedEx' : co.carrierCode))))))))))))))))))}}
                    <div *ngIf="c.shippingPreference != ''" class="badge"
                         [ngClass]="{'bg-green': c.shippingPreference == '3rd','bg-red-secondary': c.shippingPreference == '1st' || c.shippingPreference == '2nd' , 'bg-blue-secondary': c.shippingPreference == '4th'}">{{c.shippingPreference}}</div>
                  </td>
                  <td>
                    <div *ngIf="c?.deliveryMode && c?.serviceType">
                      {{c.deliveryMode + '/' + (c.serviceType || " ") | replaceStatus}}
                    </div>
                    <div *ngIf="c?.serviceType">{{c.serviceType | replaceStatus}}</div>
                    <div *ngIf="c?.deliveryMode">{{c.deliveryMode | replaceStatus}}</div>
                  </td>
                  <td>{{c.totalAmount | currency:'INR'}}</td>
                  <td>{{c.serviceAvailability}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr *ngIf="costEstimation?.length ===0 || !costEstimation?.length">
                  <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                </tr>
                </tfoot>
              </table>
              <div class="mt-2 m-3" *ngIf="others == true">
                <div class="row">
                  <div class="col-md-4 requred">
                    <div class="form-group">
                      <label class="control-label">Carrier Name</label>
                      <input type="text" id="carrierName" class="form-control" [(ngModel)]="carrierName"
                             [ngModelOptions]="{standalone: true}"
                             (blur)="carrierNameBlur()" [ngClass]="{'is-invalid':carrierNameError}">
                      <div [hidden] = "!carrierNameError" class="invalid-feedback d-block shift-invalid-login" id="carrierNameError">
                        {{carrierNameError}}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 requred">
                    <div class="form-group">
                      <label class="control-label" for="shippedDate">Shipped Date</label>
                      <input type="date" id="shippedDate" class="form-control"packageType
                             [(ngModel)]="shippedDate" [ngModelOptions]="{standalone: true}"
                             (blur)="shippedDateBlur()" [ngClass]="{'is-invalid':shippedDateError}">

                      <div [hidden] = "!shippedDateError" class="invalid-feedback d-block shift-invalid-login" id="shippedDateError">
                        {{shippedDateError}}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 requred">
                    <div class="form-group">
                      <label class="control-label">Shipment Cost</label>
                      <input type="text" id="shipmentCost" class="form-control" [(ngModel)]="shipmentCostOther"
                             [ngModelOptions]="{standalone: true}"
                             (blur)="shipmentCostOtherBlur()" [ngClass]="{'is-invalid':shipmentCostOtherError}">
                      <div [hidden] = "!shipmentCostOtherError" class="invalid-feedback d-block shift-invalid-login" id="shipmentCostOtherError">
                        {{shipmentCostOtherError}}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label">AWB Number</label>
                      <input type="text" id="AWBNumber" class="form-control" [(ngModel)]="AWBNumber"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="control-label" for="trackingURL">Tracking URL</label>
                      <input type="text" id="trackingURL" class="form-control"
                             [(ngModel)]="trackingURL" [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form [hidden]="step !== 2">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2 class="text-black mb-3 review">Review and Confirm</h2>
              </div>
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-lg-6">
                      <h2 class="text-black mb-2 review">Sender Details</h2>
                      <label class="text-black">{{order?.senderName}}</label><br>
                      <label class="text-black">{{order?.senderAddressText}}</label>
                    </div>
                    <div class="col-lg-6">
                      <h2 class="text-black mb-2 review">Receiver Details</h2>
                      <label class="text-black">{{order?.receiverName}}</label><br>
                      <label class="text-black">{{order.receiverAddressText}}</label>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <h2 class="text-black mb-2 review">Shipping Details</h2>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-black"><b>Product Config:</b><span
                        class="ml-1">{{order.productConfig | replaceStatus}}</span></label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Shipping Carrier:</b><span class="ml-1">
                        {{(shippingCost.carrierCode == 'SD' ? 'Shift' :
                        (shippingCost.carrierCode == 'DE' ? 'Delhivery' :
                        (shippingCost.carrierCode == 'GT' ? 'Gati' :
                        (shippingCost.carrierCode == 'DZ' ? 'Dotzot' :
                        (shippingCost.carrierCode == 'RD' ? 'Rapid Delivery' :
                        (shippingCost.carrierCode == 'SF' ? 'Shadow Fax' :
                        (shippingCost.carrierCode == 'VS' ? 'Vamaship' :
                        (shippingCost.carrierCode == 'BD' ? 'Blue Dart' :
                        (shippingCost.carrierCode == 'WF' ? 'Borzo' :
                        (shippingCost.carrierCode == 'PR' ? 'Pickrr' :
                        (shippingCost.carrierCode == 'DN' ? 'Dunzo' :
                        (shippingCost.carrierCode == 'SY' ? 'Shipyaari' :
                        (shippingCost.carrierCode == 'SG' ? 'Shippigo' :
                        (shippingCost.carrierCode == 'FE' ? 'FedEx' : shippingCost.carrierCode))))))))))))))}}</span></label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-black"><b>Shipping Method:</b><span
                        class="ml-1">{{order?.shippingMethod  | replaceStatus}}</span></label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Payment Mode:</b><span class="ml-1">{{order?.paymentMethod}}</span></label><br>
                      <label *ngIf="order?.totalValue" class="text-black"><b>Order Value:</b><span class="ml-1">{{order?.totalValue}}</span></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
